// extracted by mini-css-extract-plugin
export default {"successMessage":"cX_k0","thanksText":"cX_k1","detailsText":"cX_k2","twitterIcon":"cX_k3","twitterLink":"cX_k4"};